import { useState } from 'react';

import { QuotationFilters } from './filters';
import { QuotationList } from './list';

import { LayoutModule } from '../../../layout/modules';
import { QuotationFilter } from '../../../../shared/types/modules/quotation';

export const Quotation = () => {
    const [filters, setFilters] = useState<QuotationFilter>();

    return (
        <>
            <LayoutModule title="Búsqueda de cotizaciones">
                <QuotationFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <QuotationList filters={filters} />
        </>
    );
};
